import * as React from "react";
const SvgSentArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 17, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.4 20.4L21 12 3.4 3.6 3 10l12 2-12 2z", fill: "black" }));
export default SvgSentArrow;
